<template>
    <div class="search-form-wrap">
      <div
        class="search-form-item"
        v-for="(formItem, formItemIdx) in configs"
        :key="formItemIdx"
      >
        <!-- Render different input types based on form item type -->
        <InputItem
          v-if="formItem.type === '1'"
          :config="formItem"
          @change="(v) => formItemValueChange(formItem.name, v)"
        />
        <SelectItem
          v-if="formItem.type === '2'"
          :config="formItem"
          :filterOption="(row) => filterOption(formItem.tagId, row)"
          @change="(v) => formItemValueChange(formItem.name, v, formItem.tagId)"
        />
        <CheckboxItem
          v-if="formItem.type === '3'"
          :config="formItem"
          :filterOption="(row) => filterOption(formItem.tagId, row)"
          :tagsValue="categoryConf.tagsValue"
          @change="(v) => formItemValueChange(formItem.name, v, formItem.tagId)"
        />
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  import InputItem from '../InputItem.vue';
  import CheckboxItem from '../CheckboxItem.vue';
  import SelectItem from '../SelectItem.vue';
  import {findIndex} from 'lodash-es';
  import { $t } from "~/utils/index.js";
  // 接收组件传递的 props
  const props = defineProps({
    configs: {
      type: Array,
      default: () => [],
    },
    topicConfig: {
      type: Object,
      default: () => ({}),
    },
    categoryConf: {
      type: Object,
    },
  });
  
  // 定义事件 emit
  const emit = defineEmits(['formDataChange']);
  
  // 响应式数据
  const searchData = ref({});
  
  // 计算属性：处理 filterKeyMap
  const isFilterKeyMap = computed(() => {
    const setData = {};
    if (props.categoryConf?.tagsValue) {
      const setStrData = props.categoryConf.tagsValue.split(',');
      setStrData.forEach((vstr) => {
        const setKeyV = vstr.split(':');
        setData[setKeyV[0]] = {};
        setKeyV[1].split('~').forEach((v) => {
          setData[setKeyV[0]][v] = true;
        });
      });
    }
    return setData;
  });
  
  // 过滤选项
  const filterOption = (tagId, row) => {
    return !isFilterKeyMap.value[tagId] || (isFilterKeyMap.value[tagId] && isFilterKeyMap.value[tagId][row.paramDetailCode]);
  };
  
  // 处理表单项值变化
  const formItemValueChange = (name, v, tagVal) => {
    if (tagVal && name === 'tagsValue') {
      let tagsValue = searchData.value.tagsValue || '';
      let tags = tagsValue.split(';').filter((o) => !!o);
      const findIdx =  findIndex(tags, (o) => o.indexOf(tagVal + ':') === 0);
      if (findIdx >= 0) {
        if (v) {
          tags[findIdx] = tagVal + ':' + v;
        } else {
          tags.splice(findIdx, 1);
        }
      } else {
        tags.push(tagVal + ':' + v);
      }
      searchData.value.tagsValue = tags.join(';');
    } else {
      searchData.value[name] = v;
    }
  
    emit('formDataChange', searchData.value);
  };
  </script>
  
  <style scoped>
  /* 样式略去... */
  </style>
  
